'use es6';

import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import UIUsageLimitCounter from 'ui-addon-upgrades/ums/UIUsageLimitCounter';
import { jsx as _jsx } from "react/jsx-runtime";
const ContentUsage = ({
  usage: {
    count,
    limit,
    userLimit
  },
  contentType,
  usageLimitCounterUpgradeKey
}) => {
  const usageToolipMessage = count >= limit ? `salesContentIndexUI.header.usageAtLimitTooltip.${contentType}` : `salesContentIndexUI.header.usageTooltip.${contentType}`;
  if (usageLimitCounterUpgradeKey) {
    return /*#__PURE__*/_jsx(UIUsageLimitCounter, {
      upgradeKey: usageLimitCounterUpgradeKey,
      currentUsage: Math.min(count, userLimit),
      usageLimit: userLimit,
      usageLimitNextTier: 5000
    });
  }
  return /*#__PURE__*/_jsx(Tooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: usageToolipMessage,
      options: {
        count,
        limit
      }
    }),
    placement: "bottom",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "salesContentIndexUI.header.usageText",
      options: {
        count,
        limit
      }
    })
  });
};
ContentUsage.propTypes = {
  usage: PropTypes.shape({
    count: PropTypes.number,
    limit: PropTypes.number,
    userLimit: PropTypes.number
  }).isRequired,
  contentType: PropTypes.string.isRequired,
  usageLimitCounterUpgradeKey: PropTypes.string
};
export default ContentUsage;